module.exports = __webpack_public_path__ + "static/media/gradient.fb6d2f13.png";